import * as yup from "yup";

export const SensorAddValidation = yup.object({
    sensorName: yup.string().min(3).max(25).required(),
});
